import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import jQuery from 'jquery';

export default {
  documentsSearchController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$controller',
    '$filter',
    '$state',
    'searchService',
    'EDocumentStatus',
    '$timeout',
    '$sce',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $controller,
      $filter,
      $state,
      searchService,
      EDocumentStatus,
      $timeout,
      $sce
    ) {
      'use strict';

      function onClearSearchTerm() {
        $scope.clearTerm();
      }

      function goToPage(page) {
        $state.go('home.search', {
          q: $scope.searchTerm,
          f: $scope.searchFields,
          l: $scope.folderFilter,
          p: page,
        });
      }

      function loadDocuments() {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;

          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          $scope.loading = true;

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          searchService
            .execute(
              $scope.searchTerm,
              $scope.searchFields,
              $scope.isExactSearch,
              $scope.folderFilter,
              $scope.currentPage,
              $scope.pageSize
            )
            .then(
              function (data) {
                $scope.count = data.count;
                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true; //Mostra o botão caso necessario
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

                $scope.loading = false;

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  $scope.documents(data.result);

                  $scope.groups = [];

                  $scope.title = String.format(
                    $filter('translate')('SEARCH TITLE'),
                    [$scope.searchTerm]
                  );
                  $scope.description = $scope.getDescription(
                    $scope.currentPage,
                    $scope.pageSize,
                    $scope.count
                  );

                  $scope.noDocuments = $filter('translate')('NO RESULTS FOUND');
                  $scope.noDocumentsMessage = $filter('translate')(
                    'NO RESULTS FOUND MSG'
                  );
                }
              },
              function (data) {
                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers

                if (
                  data.status_code === 500 &&
                  $scope.selectedTreeItem.Name === 'CHECKOUTS'
                ) {
                  $scope.documents([]);
                  return;
                }
                swal.fire(data.error, data.error_description);
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
              }
            );
        }
      }

      function closeOptions() {
        $rootScope.displayOptions = false;
      }

      function toggleOptions() {
        $rootScope.displayOptions = !$rootScope.displayOptions;
        jQuery('#search-options').focus();
      }

      function showOptions() {
        $rootScope.displayOptions = true;
      }

      function queryTextChange() {
        $scope.hasSearchText = ($scope.options.query || '').length > 0;
        if ($scope.hasSearchText) {
          $scope.showSearchHistory = false;
        }
      }

      function onSearchFocus() {
        if (!allowSearchHistory) {
          return;
        }

        var query = ($scope.options.query || '').trim();

        if (query.length >= 3) {
          $scope.suggestions = searchService.getSearchSuggestions(query) || [];
          $scope.showSuggestions = $scope.suggestions.length > 0;
          $scope.showSearchHistory = false;
          return;
        }

        loadRecentSearches();
        $scope.showSuggestions = false;
        $scope.showSearchHistory =
          $scope.recentSearches && $scope.recentSearches.length > 0;
      }

      function onSearchBlur() {
        $timeout(function () {
          $scope.showSearchHistory = false;
        }, 200);
      }

      function selectRecentSearch(term, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        $scope.options.query = term;
        $scope.hasSearchText = true;
        $scope.showSearchHistory = false;
        $scope.showSuggestions = false;
        $scope.suggestions = [];
      }

      function removeRecentSearch(term, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        searchService.removeSearchTerm(term).then(function (terms) {
          $scope.recentSearches = terms || [];
          $scope.showSearchHistory = $scope.recentSearches.length > 0;
        });
      }

      function clearSearchHistory(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        searchService.clearSearchHistory().then(function () {
          $scope.recentSearches = [];
          $scope.showSearchHistory = false;
        });
      }

      var allowSearchHistory = false;

      function loadRecentSearches() {
        $scope.recentSearches = searchService.getRecentSearchTerms() || [];
      }

      function searchKeyPress(event) {
        //verifica se foi pressionado o enter no campo de pesquisa
        if (event.which === 13) {
          $scope.doSearch();
        }
      }

      function clearSearch() {
        $scope.clearTerm();
        $scope.closeSearch();
      }

      function clearTerm() {
        $scope.options = searchService.options;
        $scope.options.query = '';

        $scope.hasSearchText = false;

        $rootScope.displayOptions = false;
      }

      function closeSearch() {
        $rootScope.$broadcast('closeSearch');
      }

      function verifyIsAllSelected() {
        var isAllSelected = true;

        for (var o in $scope.options) {
          if (
            typeof $scope.options[o] === 'boolean' &&
            $scope.options[o] === false
          ) {
            isAllSelected = false;
            break;
          }
        }

        $scope.unselectAllText = isAllSelected
          ? $filter('translate')('UNCHECK ALL')
          : $filter('translate')('CHECK ALL');
        $scope.isSelectAll = !isAllSelected;
      }

      function unselectAll() {
        $scope.options.code = $scope.isSelectAll;
        $scope.options.additionalFields = $scope.isSelectAll;
        $scope.options.title = $scope.isSelectAll;
        $scope.options.author = $scope.isSelectAll;
        $scope.options.documentType = $scope.isSelectAll;
        $scope.options.revisionDate = $scope.isSelectAll;
        $scope.options.description = $scope.isSelectAll;
        $scope.options.extension = $scope.isSelectAll;
        $scope.options.keywords = $scope.isSelectAll;
        $scope.options.folder = $scope.isSelectAll;

        $scope.unselectAllText = $scope.isSelectAll
          ? $filter('translate')('UNCHECK ALL')
          : $filter('translate')('CHECK ALL');
        $scope.isSelectAll = !$scope.isSelectAll;
      }

      function optionChanged() {
        var query = ($scope.options.query || '').trim();

        if (!query) {
          return;
        }

        var searchFields = $scope.getSearchFields();

        if (searchFields.length > 0 || $scope.options.searchOnContent) {
          $scope.doSearch();
        }
      }

      function doSearch() {
        var query = ($scope.options.query || '').trim();

        if (!query) {
          swal.fire(
            $filter('translate')('SEARCH EMPTY'),
            $filter('translate')('SEARCH EMPTY'),
            'warning'
          );
          return;
        }

        $scope.options.query = query;

        var searchFields = $scope.getSearchFields();

        if (
          searchFields.length === 0 &&
          ($scope.options.searchOnContent === null ||
            $scope.options.searchOnContent === false)
        ) {
          swal.fire(
            $filter('translate')('SELECT FIELDS'),
            $filter('translate')('SELECT FIELDS'),
            'warning'
          );
          $rootScope.displayOptions = true;
          return;
        }

        if ($scope.selectedFolder !== null && $scope.selectedFolder.Id < 0) {
          $scope.options.folderFilter = 0;
        }

        //searchService.searchParams.SearchTerm = $scope.options.query;
        searchService.searchParams.SearchFields = searchFields;
        searchService.searchParams.StartIndex = 0;
        searchService.searchParams.PageCount = 50;
        searchService.searchParams.AllFolders =
          parseInt($scope.options.folderFilter) === 0;
        searchService.searchParams.ThisFolder =
          parseInt($scope.options.folderFilter) === 1;
        searchService.searchParams.SubFolders =
          parseInt($scope.options.folderFilter) === 2;

        if ($scope.options.folderFilter !== 0) {
          searchService.searchParams.selectedFolder = $scope.selectedFolder;
        } else {
          searchService.searchParams.selectedFolder = undefined;
        }

        $rootScope.displayOptions = false;
        $scope.showSearchHistory = false;

        $state.go('home.search', {
          q: $scope.options.query,
          p: 1,
          f: searchFields.join([';']),
          l: $scope.options.folderFilter,
          e: $scope.options.isExactSearch ? 1 : 0,
        });
        //$rootScope.$broadcast('doSearch');
      }

      function getSearchFields() {
        var searchFields = [];

        var fields = [
          'code',
          'additionalFields',
          'title',
          'author',
          'documentType',
          'revisionDate',
          'description',
          'extension',
          'keywords',
          'folder',
          'searchOnContent',
        ];

        for (var o in $scope.options) {
          if ($scope.options.hasOwnProperty(o)) {
            var i = fields.indexOf(o);
            if (i > -1) {
              var field = fields[i];

              if (field === 'keywords') {
                field = 'keyWords';
              } else if (field === 'searchOnContent') {
                field = 'content';
              }

              if ($scope.options[o] === true) {
                searchFields.push(field);
              }
            }
          }
        }

        return searchFields;
      }

      var recognition = null;

      function initVoiceSearch() {
        var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
          $scope.voiceSupported = false;
          return;
        }

        $scope.voiceSupported = true;
        recognition = new SpeechRecognition();
        recognition.lang = 'pt-BR';
        recognition.continuous = false;
        recognition.interimResults = true;
        recognition.maxAlternatives = 1;

        recognition.onstart = function () {
          $scope.$applyAsync(function () {
            $scope.isListening = true;
          });
        };

        recognition.onend = function () {
          $scope.$applyAsync(function () {
            $scope.isListening = false;
          });
        };

        recognition.onerror = function () {
          $scope.$applyAsync(function () {
            $scope.isListening = false;
          });
        };

        recognition.onresult = function (event) {
          var transcript = '';
          for (var i = event.resultIndex; i < event.results.length; i++) {
            transcript += event.results[i][0].transcript;
          }

          $scope.$applyAsync(function () {
            $scope.options.query = (transcript || '').trim();
            $scope.hasSearchText = !!$scope.options.query;
            $scope.showSearchHistory = false;
            $rootScope.displayOptions = false;
          });
        };
      }

      function toggleVoiceSearch(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (!$scope.voiceSupported || !recognition) {
          swal.fire(
            $filter('translate')('VOICE SEARCH NOT SUPPORTED'),
            $filter('translate')('VOICE SEARCH NOT SUPPORTED MSG'),
            'info'
          );
          return;
        }

        // Critérios: ocultar opções avançadas e histórico
        $rootScope.displayOptions = false;
        $scope.showSearchHistory = false;

        if ($scope.isListening) {
          recognition.stop();
          return;
        }

        try {
          recognition.start(); // o navegador pede permissão do microfone
        } catch (e) {
          recognition.stop();
        }
      }

      function stopVoiceSearch() {
        if (recognition && $scope.isListening) {
          recognition.stop();
        }
      }

      function initializeSearchField() {
        $rootScope.displayOptions = false;

        $scope.hasSearchText = $scope.searchTerm ? true : false;
        $scope.isSelectAll = false;

        $scope.selectedFolder = null;
        $scope.options = searchService.options;
        $scope.options.query = $scope.searchTerm;

        $scope.unselectAllText = $filter('translate')('UNCHECK ALL');

        $scope.itemsFilter = function (item) {
          return item.idStatus !== EDocumentStatus.TRASH_CAN;
        };

        $scope.count = 0;
        $scope.pageCount = 1;
      }

      function queryTextChange() {
        var query = ($scope.options.query || '').trim();
        $scope.hasSearchText = query.length > 0;

        $scope.showSearchHistory = false;

        if (query.length < 3) {
          $scope.suggestions = [];
          $scope.showSuggestions = false;
          return;
        }

        $scope.suggestions = searchService.getSearchSuggestions(query) || [];
        $scope.showSuggestions = $scope.suggestions.length > 0;
      }

      function highlightMatch(term, query) {
        var q = (query || '').trim();
        if (!term) {
          return '';
        }
        if (!q) {
          return $sce.trustAsHtml(term);
        }

        var lowerTerm = term.toLowerCase();
        var lowerQuery = q.toLowerCase();
        var idx = lowerTerm.indexOf(lowerQuery);

        if (idx === -1) {
          return $sce.trustAsHtml(term);
        }

        var before = term.substring(0, idx);
        var match = term.substring(idx, idx + q.length);
        var after = term.substring(idx + q.length);

        return $sce.trustAsHtml(
          before +
          '<strong class="search-suggest-match">' +
          match +
          '</strong>' +
          after
        );
      }

      function selectSuggestion(term, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        $scope.options.query = term;
        $scope.hasSearchText = true;
        $scope.showSearchHistory = false;
        $scope.showSuggestions = false;
        $scope.suggestions = [];

        $scope.doSearch();
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = '';
          $scope.description = '';
          $scope.isSearch = true;

          $scope.currentPage = $state.params.p
            ? parseInt($state.params.p) || 1
            : 1;

          $scope.pageSize = 100;
          $scope.searchTerm = $state.params.q;
          $scope.searchFields = $state.params.f;
          $scope.folderFilter = parseInt($state.params.l) || 0;
          $scope.isExactSearch = $state.params.e === '1';

          $scope.isListening = false;
          $scope.voiceSupported = false;

          $scope.suggestions = [];
          $scope.showSuggestions = false;

          $rootScope.$on(
            'clearSearchTerm',
            logWrapper(
              onClearSearchTerm,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeOptions = logWrapper(
            closeOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleOptions = logWrapper(
            toggleOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showOptions = logWrapper(
            showOptions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.queryTextChange = logWrapper(
            queryTextChange,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.searchKeyPress = logWrapper(
            searchKeyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearSearch = logWrapper(
            clearSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearTerm = logWrapper(
            clearTerm,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeSearch = logWrapper(
            closeSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.verifyIsAllSelected = logWrapper(
            verifyIsAllSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.unselectAll = logWrapper(
            unselectAll,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.optionChanged = logWrapper(
            optionChanged,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.doSearch = logWrapper(
            doSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSearchFields = logWrapper(
            getSearchFields,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadRecentSearches = logWrapper(
            loadRecentSearches,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onSearchFocus = logWrapper(
            onSearchFocus,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onSearchBlur = logWrapper(
            onSearchBlur,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectRecentSearch = logWrapper(
            selectRecentSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeRecentSearch = logWrapper(
            removeRecentSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearSearchHistory = logWrapper(
            clearSearchHistory,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initializeSearchField = logWrapper(
            initializeSearchField,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleVoiceSearch = logWrapper(
            toggleVoiceSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.stopVoiceSearch = logWrapper(
            stopVoiceSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.highlightMatch = logWrapper(
            highlightMatch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectSuggestion = logWrapper(
            selectSuggestion,
            runtimeConstant.isDebugControllersInternals
          );

          initVoiceSearch();

          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.recentSearches = [];
          $scope.showSearchHistory = false;
          $scope.configColumns();
          $scope.initializeSearchField();
          $scope.loadRecentSearches();

          $timeout(function () {
            allowSearchHistory = true;
          }, 800);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
